
import React, {createContext, useEffect, useState} from "react";
import {GetAllowedRoutes, GetAllowedSidebarElement} from "../utils/RolesChecker";
import PrivateRoutesConfig from "../config/PrivateRoutesConfig";
import MapAllowedRoutes from "./routes/MapAllowedRoutes";
import SidebarConfig from "../config/SidebarConfig";
import SideBar from "../views/Layouts/SideBar";
import TitleHelloUser from "../components/Atomes/Title/TitleHelloUser";
import {useLocation, matchPath} from "react-router-dom";
import Chatbot from "../views/Chatbot/Chatbot";
import {useAuth} from "../services/useAuth";
import {dataChatInterneAllowed} from "../utils/UserRolesUtils";
import Chat from "../views/Chat/Chat";
import MenuBurger from "../views/Layouts/MenuBurger";
import { applySeoMeta } from "../utils/seoMeta";

export const StateRequest = createContext()
function PrivateRoutes() {

    const [stateRequest, setStateRequest] = useState("");
    let allowedRoutes = [];
    let allowedSidebar = [];
    const { role } = useAuth();
    const dataChatInterne = dataChatInterneAllowed;
    const allowedRoutesChatInterne = dataChatInterne.includes(role[0]);

    allowedRoutes = GetAllowedRoutes(PrivateRoutesConfig);
    allowedSidebar = GetAllowedSidebarElement(SidebarConfig);

    const location = useLocation();
    const isHome = location.pathname === "/";

    const currentRoute = allowedRoutes.find((route) =>
        matchPath({ path: route.path, end: true }, location.pathname)
    );
    const currentSeoRoute = currentRoute || PrivateRoutesConfig.find((route) =>
        matchPath({ path: route.path, end: true }, location.pathname)
    );
    const titleHelloUser = currentRoute?.titleHelloUser;
    const pageTitle = currentRoute?.title;

    const [isSidebarExpand, setIsSidebarExpand] = useState(false);
    const toggleSidebar = () => setIsSidebarExpand(!isSidebarExpand);

    useEffect(() => {
        applySeoMeta({
            title: currentSeoRoute?.seoTitle,
            description: currentSeoRoute?.seoDescription,
        });
    }, [currentSeoRoute]);

    return (
        <StateRequest.Provider value={{ stateRequest, setStateRequest }}>
            {location.pathname === "/chatbot" ? (
                <Chatbot />
            ) : (
                <>
                    <SideBar allowedSidebar={allowedSidebar} toggleSidebar={toggleSidebar} isSidebarExpand={isSidebarExpand} />
                    <MenuBurger allowedSidebar={allowedSidebar} />
                    <div className={`page-container ${isSidebarExpand ? "page-container-collapsed" : ""}`}>
                        <div>
                            {/* Affichage du titre en fonction des conditions */}
                            {isHome && (titleHelloUser || titleHelloUser === undefined) ? (
                                <TitleHelloUser />
                            ) : !isHome && titleHelloUser ? (
                                <>
                                    {/* <h1 className={"color-primary"}><span className={"lighter"}>Page - </span>{pageTitle}</h1> */}
                                    <h1 className={"color-primary"}>{pageTitle}</h1>
                                </>
                            ) : null}

                            <MapAllowedRoutes routes={allowedRoutes} basePath="/" isAddNotFound />
                            {allowedRoutesChatInterne && <Chat stateRequest={stateRequest}  />}
                        </div>
                    </div>
                </>
            )}
        </StateRequest.Provider>
    );
}

export default PrivateRoutes;